"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var viewBox = '0 0 21 24';

var AddNew = function AddNew() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "m2.7578-0.011719c-1.5262 0-2.7695 1.2434-2.7695 2.7695v10.289c0 1.5262 1.2434 2.7715 2.7695 2.7715h6.3535a5.9546 5.9546 0 0 1 0.49609-1.0254h-6.8496c-0.9764 0-1.7461-0.76969-1.7461-1.7461v-10.289c0-0.9764 0.76969-1.7461 1.7461-1.7461h7.4082c0.9764 0 1.7461 0.76969 1.7461 1.7461v9.873a5.9546 5.9546 0 0 1 1.0254-0.42578v-9.4473c0-1.5262-1.2453-2.7695-2.7715-2.7695h-7.4082z",
    fillOpacity: ".5"
  }), _react["default"].createElement("path", {
    d: "m6.6836 4.3242c-1.5262-1e-7 -2.7695 1.2453-2.7695 2.7715v10.287c0 1.5262 1.2434 2.7715 2.7695 2.7715h2.498a5.9546 5.9546 0 0 1-0.31641-1.0254h-2.1816c-0.9764 0-1.7461-0.76969-1.7461-1.7461v-10.287c0-0.9764 0.76969-1.748 1.7461-1.748h7.4082c0.9764 0 1.7461 0.77165 1.7461 1.748v4.959a5.9546 5.9546 0 0 1 1.0254 0.29687v-5.2559c0-1.5262-1.2453-2.7715-2.7715-2.7715h-7.4082z"
  }), _react["default"].createElement("path", {
    d: "m14.689 13.516a0.70465 0.70465 0 0 0-0.70508 0.70508v2.9707h-2.8594a0.70465 0.70465 0 0 0-0.70508 0.70508 0.70465 0.70465 0 0 0 0.70508 0.70312h2.8594v2.959a0.70465 0.70465 0 0 0 0.70508 0.70508 0.70465 0.70465 0 0 0 0.70508-0.70508v-2.959h3.0684a0.70465 0.70465 0 0 0 0.70508-0.70312 0.70465 0.70465 0 0 0-0.70508-0.70508h-3.0684v-2.9707a0.70465 0.70465 0 0 0-0.70508-0.70508z"
  }));
};

var _default = (0, _createSvgIcon["default"])(AddNew, {
  viewBox: viewBox
});

exports["default"] = _default;